var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.itemLoaded && _vm.routeDataLoaded)?_c('div',{staticClass:"profile-invoice",attrs:{"fluid":""}},[_c('single-invoice',{attrs:{"invoice":_vm.item}})],1):_c('layout-loading')
}
var staticRenderFns = []

export { render, staticRenderFns }